import React, { useEffect, useState } from 'react'
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as bie from "react-bootstrap";
import { viewImage } from '../../CommonUtils/viewImage';
import { FaCheck, FaHome, FaTimes } from 'react-icons/fa';

export default function FFCAAfflClgRegistrationReport() {
  const [statusObj, setStatusObj] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [allDone, setAllDone] = useState(false);
  const acYear = sessionStorage.getItem('ac_year');

  const fieldToStepIndex = {
    ffca_mem_section: 0,
    fee_due_univ: 1,
    ffca_link_upload: 2,
    ffca_build_blocks: 3,
    ffca_instruct_area: 4,
    ffca_admin_area: 5,
    ffca_lab_area: 6,
    ffca_ques_sect_1: 7,
    ffca_ques_sect_2: 8,
    ffca_ques_sect_3: 9,
    ffca_ques_sect_4: 10,
    ffca_deficiencies: 11,
    ffca_remarks: 12,
  };

  const stepTitles = [
    "Membership Section",
    "Fee Due to University",
    "Link Upload",
    "Building Blocks",
    "Instructional Area",
    "Administrative Area",
    "Lab Area",
    "Questionnaire Section-I",
    "Questionnaire Section-II",
    "Questionnaire Section-III",
    "Questionnaire Section-IV",
    "FFCA Deficiencies",
    "Feedback/Final Submission",
  ];

  function computeCurrentStep(status) {
    for (const [field, idx] of Object.entries(fieldToStepIndex)) {
      if (status[field] !== 'Done') {
        return idx + 1;
      }
    }
    return stepTitles.length;
  }

  function isAllDone(status) {
    return Object.keys(fieldToStepIndex).every(
      field => status[field] === 'Done'
    );
  }

  function GetData() {
    const url = `${config.url.API_URL}getFfcaSectionStatus`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        const obj = res.data.getFfcaSectionStatus[0];
        setStatusObj(obj);
        setCurrentStep(computeCurrentStep(obj));
        setAllDone(isAllDone(obj));
      } else {
        setStatusObj({});
        setCurrentStep(0);
        setAllDone(false);
      }
    });
  }
  const userid = (sessionStorage.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage.getItem('user_id').split('_')[1] : sessionStorage.getItem('user_id');

  function GetFfcaSubmissionPdf() {
    const url = `${config.url.API_URL}getFfcaPdf/${userid}/${acYear}`;
    CommonAxiosPost(url).then((res) => {
      if (res?.data?.Status) {
        viewImage(res.data.path);
      } else {
        console.log("No Data Found");
      }
    });
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
      <div className="inner-herbpage-service-title1">
        <bie.Row>

          <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className='mb-2'>

            {/* <h5 className="mb-0">College Status, AcYear {acYear}</h5> */}
          </bie.Col>
          <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>

            <button className="breadcrumb-item">
              <a href="/dashboard" className="affl-dash">
                <FaHome size={30} />
              </a>
            </button>
          </bie.Col>
        </bie.Row>
      </div>

      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <div className="inner-herbpage-service-title-sub pt-0 mb-3 d-flex align-items-center">
          <h1 className="mb-0">
            College Name: <span>{statusObj.inst_name}</span>
          </h1>
          <h1 className="mb-0 ms-4">
            College Code: <span>{statusObj.coll_code}</span>
          </h1>
        </div>

        <bie.Container fluid className="pt-5 d-flex justify-content-center">
          <bie.Row>
            <bie.Col md={12} className="px-4">
              <div className="vertical-stepper">

                {stepTitles?.map((title, i) => {
                  const stepIndex = i + 1;
                  const fieldName = Object.keys(fieldToStepIndex)
                    .find(key => fieldToStepIndex[key] === i);
                  const val = statusObj[fieldName];
                  const isDone = val === 'Done';  // ✅ boolean
                  const isActive = stepIndex === currentStep;

                  return (
                    <div key={fieldName} className="stepper-step d-flex mb-4">
                      <div className="icon-column d-flex flex-column align-items-center">
                        <div className={`step-circle ${isDone ? 'completed' : isActive ? 'active' : 'pending'}`}>
                          {isDone ? <FaCheck /> : stepIndex}
                        </div>
                        {i < stepTitles.length - 1 && (
                          <div className={`step-line ${stepIndex < currentStep ? 'line-completed' : ''}`}></div>
                        )}
                      </div>

                      <button
                        type="button"
                        className="step-text ps-3"
                        onClick={() => setCurrentStep(stepIndex)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className={`step-label ${isDone ? 'label-done' : ''} ${isActive ? 'active-label' : ''}`}>
                          {title}
                        </div>
                        <div className="step-status mt-1">
                          <bie.Badge bg={isDone ? "success" : "danger"}>
                            {isDone
                              ? (<><FaCheck className="me-1" /> Done</>)
                              : (<><FaTimes className="me-1" /> Not Done</>)
                            }
                          </bie.Badge>
                        </div>
                      </button>
                    </div>
                  );
                })}
              </div>
            </bie.Col>
          </bie.Row>
        </bie.Container>
        {allDone && (
          <center>
            <button
              type="button"
              className="btn btn-sm affl-print me-2"
              onClick={() => GetFfcaSubmissionPdf()}
            >
              Print PDF
            </button>
          </center>
        )}
      </bie.Container>
    </>
  );
}
